import React from "react";
import LuggageIcon from "@mui/icons-material/Luggage";

interface NoDataFlightCardProps {
  icon?: React.ReactNode;
  headingText?: string;
  paragraph?: string;
}

const NoDataFlightCard: React.FC<NoDataFlightCardProps> = ({
  headingText,
  icon,
  paragraph,
}) => {
  return (
    <div className="row justify-content-center">
      {/* <div className="col-md-4"> */}
      <div
        className="text-white p-3  rounded-md border border-amber-100"
        style={{ backgroundColor: "#fffbeb", width: "300px" }}
      >
        <div className="flex justify-content-center align-item-center">
          {icon}
          <div>
            <h4 className=" no-data-color p-1">{headingText}</h4>
            <p className="no-data-color">{paragraph}</p>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default NoDataFlightCard;
